export const appVersion = '241207-1136';

export const appInfo = {
  name: 'Erajaya Redemption Portal',
  nameUC: 'Erajaya Redemption Portal',
  logo: 'Erajaya',
  network: 'Erajaya',
  website: 'https://broker.bolttech.id/redemption/erajaya',
};

export const applicationBase = {
  name: 'Erajaya',
  angular: 'Angular 19.0.5',
  bootstrap: 'Bootstrap 5.3.3',
  fontawesome: 'Font Awesome 6.7.2',
};

